import { MuiTooltip } from "@common";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
// =============================================================================================

const CommonVisibilityIcon = ({ handleClick, tooltip }) => {
    return (
        <MuiTooltip title={tooltip || "View Details"} placement="bottom">
            <IconButton
                onClick={handleClick}
                style={{ padding: 0 }}
            >
                <VisibilityIcon color="primary" />
            </IconButton>
        </MuiTooltip>
    )
}

export default CommonVisibilityIcon